import * as React from "react";
import XButton from "../assets/X.svg";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export function ArtistSelectionSlider(props) {
    let sortedNameSets = props.artistNames;
    sortedNameSets.sort((a, b) => a[0] - b[0]);

    let navigate = useNavigate();
    return (
        <Box 
            sx={{
                height: "24.68vh",
                minWidth: "293.3px",
                background: "#656565 0% 0% no-repeat padding-box;",
                borderRadius: "2.3148vh 2.3148vh 0px 0px",
                position: "absolute",
                top: "100vh",
                left: "50%",
                transform: props.sliderOpen
                    ? "translate(-50%,-100%)"
                    : "translate(-50%,0%)",
                transition: "transform 0.6s",
                transitionTimingFunction: "cubic-bezier(0,.97,.93,1.01)",
                aspectRatio:"1200/533",
                display: {
                    start: "none",
                    xl: "inline"
                }
                
            }}
        >
            <img
                alt="X button"
                src={XButton}
                onClick={() => {
                    props.setSliderOpen(!props.sliderOpen);
                }}
                style={{
                    height:".9259vh",
                    position: "relative",
                    left: "95%",
                    top: "5%"
                }}
            />
            <Box
                sx={{

                    display: "grid",
                    gridTemplateColumns: "28% 45% 27%",
                    gridTemplateRows: "repeat(6 1fr)",
                    padding: "1.859vh 2.778vh 2.778vh 2.778vh",
                    height: "90%",
                }}
            >
                {sortedNameSets.map((nameSet, index) => (
                    <Box
                        key={nameSet[0]}
                        sx={{         
                            borderBottom: index < 15 ? "1px solid #f2f2f2" : "",
                            display: "table"
                        }}
                    >
                        <Typography
                            onClick={() => {
                                props.setSliderOpen(false);
                                props.setExitPage(true);
                                setTimeout(() => {
                                    navigate(`/profile/${nameSet[1]}`);
                                }, props.exitDelay);
                            }}
                            sx={{
                                fontFamily: "GT Eesti Display Bold",
                                fontSize: "1.111vh",
                                lineHeight: "1.296vh",
                                letterSpacing: "0.48px",
                                color: "text.primary",
                                textAlign: "left",
                                textDecoration: "none",
                                display: "table-cell",
                                verticalAlign: "middle"
                            }}
                        >
                            {nameSet[2]}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}
